import { Button } from "../button";

import { useFormContext } from "./form";

type FormSubscribeButtonProps = React.ComponentProps<typeof Button>;

function FormSubscribeButton({
  children,
  type = "submit",
  ...props
}: FormSubscribeButtonProps) {
  const form = useFormContext();

  return (
    <form.Subscribe selector={(state) => [state.isSubmitting] as const}>
      {([isSubmitting]) => (
        <Button type={type} disabled={isSubmitting} {...props}>
          {children}
        </Button>
      )}
    </form.Subscribe>
  );
}

export { FormSubscribeButton };
